// extracted by mini-css-extract-plugin
module.exports = {"tabSet":"TabSet_tabSet__2G-Td","divider":"TabSet_divider__1q50k","frame":"TabSet_frame__2zSVO","content":"TabSet_content__1gLvD"};